import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, FormBuilder, NgForm, Validators,FormArray } from '@angular/forms';
import {MyserviceService} from '../myservice.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  providers:[MyserviceService]
})
export class SignupComponent implements OnInit {
  gender:Array<string>=["male","female"];
  signupForm:FormGroup;
  signup_data={
    name:'',
    age:-1,
    gen:'',
    email:'',
    username:'',
    password:''
  }
  constructor(private fb: FormBuilder,private serv:MyserviceService,private router:Router) {
   }
  ngOnInit(): void {
    this.signupForm=this.fb.group({
      name:[null,[Validators.required]],
      age:[null,[Validators.required]],
      gen:[null,[Validators.required]],
      email:[null,[Validators.required,Validators.email]],
      username:[null,[Validators.required,Validators.minLength(8)]],
      password:[null,[Validators.required,Validators.minLength(8)]],
    });
  }

  val:boolean=false;
  onsubmit(){

    console.log(this.signupForm.controls.username.value);

    this.signup_data={
      name:this.signupForm.controls.name.value,
      age:this.signupForm.controls.age.value,
      gen:this.signupForm.controls.gen.value,
      email:this.signupForm.controls.email.value,
      username:this.signupForm.controls.username.value,
      password:this.signupForm.controls.password.value
    }
    console.log(this.signup_data);
    this.serv.userLogin(this.signup_data.username).subscribe(
      data=>{
        console.log("val ",data);
        this.val=true;
      },
      error=>{
        this.val=false;
        console.log("Error");
      }
    );
    if(this.val==false){
    this.serv.userSignUp(this.signup_data).subscribe(
      data=>{
        console.log("data is posted");
        this.signup_data=data;
        console.log(this.signup_data);
        //localStorage.setItem('LogedIn',true);
        localStorage.setItem('log','true');
        localStorage.setItem('loginUser',JSON.stringify(this.signup_data));
        this.router.navigate(['user']);
        alert("You are signed in");
      },
      error=>{
        console.log("flash ERROR");
      }
    );
  }
  }
}
